import { action, observable, reaction, makeObservable } from 'mobx';
import {PagedListResponse, User, userLoaders} from '../../../domain';
import {Disposers, HttpPromiseState} from '../../../lib/helpers';
import {UserSearchFormStore} from './UserSearchFormStore';


export class UserSearchStore {
  @observable
  currentPage: number = 0;

  form: UserSearchFormStore;

  @observable.ref
  resultState: HttpPromiseState<PagedListResponse<User>> | null;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.currentPage = 0;
    this.form = new UserSearchFormStore();
    this.resultState = null;

    this.setup();
  }

  @action
  private resetResults = () => {
    this.currentPage = 0;
    this.resultState = null;
  };

  loadResults = () => {
    if (this.resultState?.isPending === true)
      return;
    this.form.markAllTouched();
    if (this.form.invalid)
      return;

    const model = this.form.model;
    model.Page = this.currentPage;

    this.resultState = userLoaders.search(model);
  };

  @action
  loadNextPage = () => {
    this.resetResults();
    this.currentPage++;
    this.loadResults();
  };

  @action
  loadPreviousPage = () => {
    this.resetResults();
    this.currentPage--;
    this.loadResults();
  };

  private setup() {
    this.disposers.add(
      reaction(
        () => this.form.model,
        this.resetResults));
  }

  dispose = () => {
    this.disposers.dispose();
  };
}
